<template>
    <div class="container-fluid" >
        <headerApp :title="this.translate('seleccionarPromocion')"></headerApp>
        <div class="row">
            <div class="col-xs-24">
                <div class="col-container">
                    <div class="counter-banner" v-if="catalogo">
                        {{ translate('beneficiosRestantes', {
                            restantes: catalogo.tarjetas_restantes,
                            maximas: catalogo.tarjetas_maximas
                        }) }}
                    </div>
                    <div v-if="!waiting && randomPromotions && randomPromotions.length > 0 && catalogo && catalogo.tarjetas_restantes > 0">
                        <div class="media" v-for="item in randomPromotions" v-bind:key="item.id" :class="promotionSelected && item.id === promotionSelected.id ? 'promotion-selected' : ''" @click="onPromotionSelected(item)">
                            <div class="media-left">
                                <img :src="profilePic(item)" alt="" class="logo-anunciante">
                            </div>
                            <div class="media-body">
                                <div class="anunciante-name">{{ item.anunciante.name }}</div>
                                <div><small>{{ item.anunciante.address }} / {{ item.anunciante.phone }}</small>
                                </div>
                                <div v-if="item.discount || item.products">
                                    <div class="discount-offer">
                                        <strong>{{ item.discount }}%</strong>
                                        <span v-if="item.products">
                                            <span v-lang.en></span>:
                                            {{ item.products }}
                                        </span>
                                    </div>
                                </div>
                                <div v-if="item.promotion">{{ item.promotion }}</div>
                                <div v-if="item.condiciones"><small>{{ item.condiciones }}</small></div>
                            </div>
                            <button class="btn btn-primary" v-on:click.stop="onConfirmSelection(item)">{{ translate('seleccionar') }}</button>
                        </div>
                        <button class="btn btn-primary btn-lg btn-heavy" v-lang.quieroEsaPromo @click="onConfirmSelection(null)">
                            Quiero esa promo.
                        </button>
                        <button class="btn btn-secondary btn-lg btn-heavy btn-finish" @click="onFinish">
                            {{ translate('finalizarSeleccion') }}
                        </button>
                    </div>
                    <div v-if="!waiting && (!catalogo || catalogo.tarjetas_restantes <= 0 || !randomPromotions.length)" class="form">
                        <p v-if="catalogo && catalogo.tarjetas_restantes <= 0">{{ translate('beneficiosLimiteAlcanzado') }}</p>
                        <p v-else>{{ translate('sinPromocionesDisponibles') }}</p>
                        <button class="btn btn-primary btn-lg btn-heavy" @click="onFinish">{{ translate('finalizarSeleccion') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dialogs from '@/services/dialogs';
let defaultProfilePic = require('@/assets/img/default.jpg');

export default {
    name: 'select-promotion',
    props: [
        'zona',
        'viaje'
    ],
    data () {
        return {
            waiting: false,
            catalogo: null,
            promotions: [],
            promotionSelected: null,
            tarjetasCreadas: 0
        };
    },
    computed: {
        ...mapGetters({
            settings: 'company/config'
        }),
        randomPromotions () {
            let promotions = [];
            if (this.promotions && this.promotions.length) {
                promotions = this.promotions.slice(0);
                let currentIndex = promotions.length;
                let temporaryValue;
                let randomIndex;
                while (currentIndex !== 0) {
                    randomIndex = Math.floor(Math.random() * currentIndex);
                    currentIndex -= 1;
                    temporaryValue = promotions[currentIndex];
                    promotions[currentIndex] = promotions[randomIndex];
                    promotions[randomIndex] = temporaryValue;
                }
            }
            return promotions;
        },
        vigenciaDias () {
            if (this.catalogo && this.catalogo.vigencia_dias) {
                return this.catalogo.vigencia_dias;
            }
            if (this.settings && this.settings.beneficios_vigencia_dias) {
                return this.settings.beneficios_vigencia_dias;
            }
            return 5;
        }
    },
    mounted () {
        this.language = this.$getLang();
        this.loadCatalogo();
    },
    methods: {
        ...mapActions({
            getBeneficiosCatalogo: 'passenger/getBeneficiosCatalogo',
            crearTarjetaBeneficio: 'passenger/crearTarjetaBeneficio'
        }),
        loadCatalogo () {
            let data = {
                zona_id: this.zona,
                viaje_id: this.viaje
            };
            this.waiting = true;
            this.getBeneficiosCatalogo(data).then((catalogo) => {
                this.waiting = false;
                this.catalogo = catalogo;
                this.promotions = catalogo.promociones || [];
            }).catch(() => {
                this.waiting = false;
                dialogs.message(this.translate('conectionError'), { duration: 10, estado: 'error' });
            });
        },
        profilePic (item) {
            return item.anunciante.logo ? this.$profile(item.anunciante.logo) : defaultProfilePic;
        },
        onPromotionSelected (item) {
            if (this.promotionSelected && this.promotionSelected.id === item.id) {
                this.promotionSelected = null;
            } else {
                this.promotionSelected = item;
            }
        },
        onConfirmSelection (item) {
            if (!this.promotionSelected && !item) {
                dialogs.message(this.translate('debeSeleccionarUnaPromo'), { duration: 10, estado: 'error' });
                return;
            }
            let promo = item || this.promotionSelected;
            let data = {
                promocion_id: promo.id,
                viaje_id: this.viaje
            };
            this.crearTarjetaBeneficio(data).then(() => {
                this.tarjetasCreadas += 1;
                dialogs.message(this.translate('tarjetaCreadaExito', {
                    dias: this.vigenciaDias
                }), {
                    duration: 8,
                    estado: 'success'
                });
                this.promotionSelected = null;
                this.loadCatalogo();
            }).catch((error) => {
                let code = error && error.data;
                if (code === 'max_cards_reached') {
                    dialogs.message(this.translate('beneficiosLimiteAlcanzado'), { duration: 10, estado: 'error' });
                } else if (code === 'promotion_already_selected') {
                    dialogs.message(this.translate('promocionYaElegida'), { duration: 10, estado: 'error' });
                } else if (code === 'trip_not_finished') {
                    dialogs.message(this.translate('viajeNoFinalizadoBeneficio'), { duration: 10, estado: 'error' });
                } else {
                    dialogs.message(this.translate('conectionError'), { duration: 10, estado: 'error' });
                }
            });
        },
        onFinish () {
            if (this.tarjetasCreadas > 0) {
                this.$router.push({ name: 'promotions' });
            } else {
                this.$router.push({ name: 'home' });
            }
        }
    }
};
</script>

<style scoped>
    .container-fluid {
        background: var(--form-background-color);
        min-height: 100%;
    }
    .col-container {
        padding: 0 .4em;
    }
    .counter-banner {
        background: white;
        padding: 1em;
        margin-top: 1em;
        text-align: center;
        font-weight: bold;
    }
    .media {
        background: white;
        margin-top: 1.5em;
    }
    .media-left img {
        max-height: 9em;
        max-width: 30vw;
    }
    .media-body {
        padding: 8px 4px;
    }
    .anunciante-name {
        font-size: 1.11em;
        font-weight: bold;
    }
    .discount-offer {
        font-size: 1.4em;
        margin: 8px 0;
        color: var(--main-color);
    }
    .promotion-selected {
        box-shadow: 0 0 3px 3px var(--primary-button-bg-color);
    }
    .btn-finish {
        margin-top: 1em;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/SelectPromotion.vue